import { Button } from "@mui/material";
import {
	ReplacementsAddToOrderButtonText,
	ReplacementsCancelButtonText,
	ReplacementsSelectAPartError
} from "constants/text";
import styles from "pages/replacements-page-styles.module.css";
import { KeyboardEvent, MouseEvent } from "react";

interface FlyoutFooterProps {
	selectPartError: boolean;
	closeDrawer: (event: KeyboardEvent | MouseEvent) => void;
	addToOrderHandler: () => void;
}

const FlyoutFooter = ({ selectPartError, closeDrawer, addToOrderHandler }: FlyoutFooterProps) => {
	return (
		<div style={{ padding: "16px 0", boxSizing: "border-box" }}>
			{selectPartError && (
				<p
					className={`body2  ${styles.errorText}`}
					data-testid="replacements-flyout-select-part-error-message"
				>
					{ReplacementsSelectAPartError}
				</p>
			)}
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					gap: "16px"
				}}
			>
				<Button
					fullWidth
					data-testid="replacements-flyout-cancel-button"
					variant="outlined"
					onClick={closeDrawer}
				>
					{ReplacementsCancelButtonText}
				</Button>
				<Button
					fullWidth
					onClick={addToOrderHandler}
					data-testid="replacements-flyout-add-to-order-button"
					variant="contained"
				>
					{ReplacementsAddToOrderButtonText}
				</Button>
			</div>
		</div>
	);
};

export default FlyoutFooter;
